import { onMounted, onUnmounted } from 'vue'

import type { MeetingUpdatedEvent } from '@app/application/client_meetings/screens/past/events'
import useSfPolling from '@app/shared/vue/composables/use-sf-polling'
import { usePastMeetingsStore } from '@app/application/client_meetings/screens/past/stores/past-meetings'

export const useMeetingUpdates = ({
  channelName,
  lastId,
}: {
  channelName: string
  lastId: number
}): void => {
  let stopCompletedPolling: (() => void) | null = null

  const pastMeetingsStore = usePastMeetingsStore()

  async function handleMeetingUpdated(
    data: MeetingUpdatedEvent
  ): Promise<void> {
    // Id-only event: content is fetched through the authorized endpoint.
    if (!pastMeetingsStore.meetingsById[data.meeting_id]) {
      return
    }

    await pastMeetingsStore.fetchPastMeeting(data.meeting_id)
  }

  function setupMessageBusSubscription(): void {
    const { startPolling } = useSfPolling<typeof handleMeetingUpdated>()

    stopCompletedPolling = startPolling(
      channelName,
      lastId,
      () => true, // Always continue polling
      handleMeetingUpdated
    )
  }

  function cleanupMessageBusSubscription(): void {
    if (stopCompletedPolling) {
      stopCompletedPolling()
      stopCompletedPolling = null
    }
  }

  function subscribeToChanges(): void {
    cleanupMessageBusSubscription()
    setupMessageBusSubscription()
  }

  onMounted(() => subscribeToChanges())
  onUnmounted(() => cleanupMessageBusSubscription())
}
